import Button from "@common/components/Button";
import { RoomsRealtimeContext } from "@common/components/ListDetailViews/Layout/context";
import { useErrorNotification } from "@common/components/Notification";
import { useSimpleReducer } from "@common/hooks";
import { FavoriteBorder } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { addCustomRoomToFavorites } from "@services/meetings";
import { CustomRoom, Protocol } from "@services/meetings/types";
import { useAuthenticatedUser } from "@services/user/hooks/useAuthenticatedUser";
import React from "react";
import { useTranslation } from "react-i18next";
import { AddParticipantContext } from "../..";
import CustomRoomForm from "../../CustomRoomForm";

type OtherTabProps = {};

const OtherTab = (props: OtherTabProps) => {
  const {} = props;
  const { selectedRooms, dispatch, fetchData } = React.useContext(
    AddParticipantContext
  );
  const [user] = useAuthenticatedUser();
  const context = React.useContext(RoomsRealtimeContext);
  const dispatchError = useErrorNotification();
  const { t } = useTranslation();
  const [{ name, protocol, address, extension, disableButtons }, setForm] =
    useSimpleReducer<{
      disableButtons: boolean;
      name: string;
      protocol: Protocol;
      address: string;
      extension: string;
    }>({
      disableButtons: false,
      name: "",
      protocol: Protocol.H323,
      address: "",
      extension: "",
    });

  const handleOnClickAdd = (id?: number) => {
    const tmp = selectedRooms;
    const customRoom: CustomRoom = {
      name,
      protocol,
      address,
      extension,
      external: true,
      userId: user?.id,
      id: id !== undefined ? id : Date.now(),
    };
    tmp.push(customRoom);
    dispatch({ selectedRooms: tmp });
    setForm({
      name: "",
      protocol: Protocol.H323,
      address: "",
      extension: "",
    });
  };
  const isValidForm = name !== "" && protocol !== undefined && address !== "";

  return (
    <Grid
      container
      direction="column"
      sx={{ width: '100%', gap: "1rem", }}
    >
      <CustomRoomForm
        name={name}
        protocol={protocol}
        address={address}
        extension={extension}
        setForm={setForm}
      >
        <Button
          disabled={disableButtons || !isValidForm}
          color="meeting"
          onClick={() => handleOnClickAdd()}
        >
          {t("Add")}
        </Button>
      </CustomRoomForm>
    </Grid>
  );
};

export default OtherTab;
